import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AUTH_TOKEN } from "constants/AuthConstant";
import CollateralDocumentService from "services/Setup/Organization/collateralDocumentService";
import { notification } from "antd";

export const initialState = {
  loading: false,
  message: "",
  showMessage: false,
  redirect: "",
  token: localStorage.getItem(AUTH_TOKEN) || null,
  result: {},
  CollateralDocumentList: {},
  refreshList: false,
  CollateralDocumentApprovalList: {},
  getPageSize: "",
  getPageIndex: "",
  getCount: "",
};

export const postCollateralDocument = createAsyncThunk(
  "collateralDocument/postCollateralDocument",
  async (data, { rejectWithValue }) => {
    try {
      const response = await CollateralDocumentService.postCollateralDocument(
        data
      );
      console.log("🚀 ~ response:", response);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          // message.success({
          //   status: response.data.status,
          //   content: response.data.message,
          // });
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          // message.error({
          //   status: response.data.status,
          //   content: response.data.message,
          // });
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error:", error);
      // message.error({
      //   status: error,
      //   content: error,
      // });
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getCollateralDocumentList = createAsyncThunk(
  "collateralDocument/getCollateralDocumentList",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await CollateralDocumentService.getCollateralDocumentList(userInput);
      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        console.log("Selain Response 200");
        // notification.error({
        //   message: "Error",
        //   description: "Unexpected response!",
        //   duration: 3,
        // });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getCollateralDocumentApprovalList = createAsyncThunk(
  "collateralDocument/getCollateralDocumentApprovalList",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await CollateralDocumentService.getCollateralDocumentApprovalList(
          userInput
        );
      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const putCollateralDocumentApproval = createAsyncThunk(
  "collateralDocument/putCollateralDocumentApproval",
  async (data, { rejectWithValue }) => {
    try {
      const response =
        await CollateralDocumentService.putCollateralDocumentApproval(data);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const putCollateralDocumentRequest = createAsyncThunk(
  "collateralDocument/putCollateralDocumentRequest",
  async (data, { rejectWithValue }) => {
    try {
      const response =
        await CollateralDocumentService.putCollateralDocumentRequest(data);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          // message: "Error",
          // description: "Unexpected response!",
          message: response.status,
          description: response.statusText,
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getCollateralDocumentDetail = createAsyncThunk(
  "collateralDocument/getCollateralDocumentDetail",
  async (data, { rejectWithValue }) => {
    try {
      const response =
        await CollateralDocumentService.getCollateralDocumentDetail(data);
      if (response.status === 200) {
        if (response && response.data) {
          return response;
        }
      } else {
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const updateCollateralDocument = createAsyncThunk(
  "collateralDocument/updateCollateralDocument",
  async (data, { rejectWithValue }) => {
    try {
      const response = await CollateralDocumentService.updateCollateralDocument(
        data
      );
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const deleteCollateralDocument = createAsyncThunk(
  "collateralDocument/deleteCollateralDocument",
  async (data, { rejectWithValue }) => {
    try {
      const response = await CollateralDocumentService.deleteCollateralDocument(
        data
      );
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const CollateralDocumentSlice = createSlice({
  name: "collateralDocument",
  initialState,
  reducers: {
    showNotification: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    hideNotification: (state) => {
      state.message = "";
      state.showMessage = false;
    },
    showLoading: (state) => {
      state.loading = true;
    },
  },

  extraReducers: (builder) => {
    builder

      //post
      .addCase(postCollateralDocument.pending, (state) => {
        state.loading = true;
      })
      .addCase(postCollateralDocument.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.result = action.payload;
        state.showMessage = true;
        state.message = action.payload.data.message;
        state.refreshList = true;
      })
      .addCase(postCollateralDocument.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //list
      .addCase(getCollateralDocumentList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getCollateralDocumentList.fulfilled, (state, action) => {
        state.loading = false;
        state.CollateralDocumentList = action.payload;
        state.getCount = action.payload.count;
      })
      .addCase(getCollateralDocumentList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //CollateralDocument approval list
      .addCase(getCollateralDocumentApprovalList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getCollateralDocumentApprovalList.fulfilled, (state, action) => {
        state.loading = false;
        state.CollateralDocumentApprovalList = action.payload;
        state.getCount = action.payload.count;
      })
      .addCase(getCollateralDocumentApprovalList.rejected, (state, action) => {
        state.loading = false;
        state.CollateralDocumentApprovalList = action.payload;
      })

      //CollateralDocument approval approve
      .addCase(putCollateralDocumentApproval.pending, (state) => {
        state.loading = true;
        // state.redirect = "";
      })
      .addCase(putCollateralDocumentApproval.fulfilled, (state, action) => {
        state.loading = false;
        // state.result = action.payload;
        // state.showMessage = true;
      })
      .addCase(putCollateralDocumentApproval.rejected, (state, action) => {
        state.loading = false;
        // state.result = action.payload;
        // state.showMessage = true;
      })

      //CollateralDocument approval request
      .addCase(putCollateralDocumentRequest.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(putCollateralDocumentRequest.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(putCollateralDocumentRequest.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //detail
      .addCase(getCollateralDocumentDetail.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCollateralDocumentDetail.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(getCollateralDocumentDetail.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //update
      .addCase(updateCollateralDocument.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateCollateralDocument.fulfilled, (state, action) => {
        state.loading = false;
        // state.redirect = "/";
        // state.result = action.payload;
        // state.showMessage = true;
      })
      .addCase(updateCollateralDocument.rejected, (state, action) => {
        state.loading = false;
        // state.result = action.payload;
        // state.showMessage = true;
      })

      //delete
      .addCase(deleteCollateralDocument.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteCollateralDocument.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(deleteCollateralDocument.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      });
  },
});

export const {
  //    update,
  showNotification,
  hideNotification,
  showLoading,
} = CollateralDocumentSlice.actions;

export default CollateralDocumentSlice.reducer;
